import { useRef } from 'react';
import PropTypes from 'prop-types';

import { useWarpTransition } from './WarpTransitionProvider';

const WarpRouteStage = ({ location, children }) => {
  const { isTransitioning } = useWarpTransition();
  const visibleLocationRef = useRef(location);

  if (!isTransitioning) {
    visibleLocationRef.current = location;
  }

  return children(visibleLocationRef.current);
};

WarpRouteStage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.func.isRequired,
};

export default WarpRouteStage;
